// Copyright (c) 2019 Sagacity Solutions Inc. All right reserved.

import moment from "moment";

import HTTP from "./http-server";

export default {
  getVersion: async function () {
    let response = await HTTP.get('version')
    if (response.status == 200) {
      return response.data.version;
    }
    return '--';
  },
  storeSchedule: async function (schedule) {
    let response = await HTTP.post('v1/schedules/', schedule);
    if (response.status == 200) {
      return response.data;
    }
    throw new Error(response.status);
  },
  removeSchedule: async function (schedule) {
    let response = await HTTP.delete(`v1/schedules/${schedule.ID}/`);
    if (response.status == 200) {
      return true;
    }
    throw new Error(response.status);
  },
  getEventForTagID: async function (tagid) {
    if (tagid === undefined)
      throw new Error(400);

    let response = await HTTP.get(`v1/tag/${tagid}/`, {
      headers: {
        'X-TIMESTAMP': moment().format()
      }
    });
    if (response.status == 200) {
      return response.data;
    }
    throw new Error(response.status);
  },
  assignCardToEAC: async function (scheduleid, code) {
    console.log("EAC api", code)
    let response = await HTTP.post(`v1/schedules/${scheduleid}/assign/eac`, { code: code })
    if (response.status == 200) {
      return response.data;
    }
    throw new Error(response.status)
  },
  assignCardToNFC: async function (scheduleid, code) {
    let response = await HTTP.post(`v1/schedules/${scheduleid}/assign/nfc`, { code: code })
    if (response.status == 200) {
      return response.data;
    }
    throw new Error(response.status)
  },
  cloneSchedule: async function (schedule) {
    let response = await HTTP.post('v1/schedules/clone', schedule);
    if (response.status == 200) {
      return response.data;
    }
    throw new Error(response.status);
  },
  confirmDoseIntake: async function (dose) {
    let response = await HTTP.post(`v1/tag/${dose.tagid}/`, dose, {
      headers: {
        'X-TIMESTAMP': moment().format()
      }
    });
    if (response.status == 200) {
      return response.data;
    }
    throw new Error(response.status);
  },
  getDosesForSchedule: async function (scheduleid) {
    let response = await HTTP.get(`v1/schedules/${scheduleid}/doses`);
    if (response.status == 200) {
      return response.data;
    }
    throw new Error(response.status);
  },
  removeDose: async function (dose) {
    let response = await HTTP.delete(`v1/doses/${dose.ID}/`);
    if (response.status == 200) {
      return true;
    }
    throw new Error(response.status);
  },
  createDose: async function (dose) {
    let response = await HTTP.post('v1/doses/', dose);
    if (response.status == 200) {
      return response.data;
    }
    throw new Error(response.data);
  },
  updateDose: async function (dose) {
    let response = await HTTP.put(`v1/doses/${dose.ID}/`, dose)
    if (response.status == 200) {
      return response.data;
    }
    throw new Error(response.data);
  },
  updateMultiDoses: async function (doses) {
    let response = await HTTP.put('v1/doses/', doses);
    if (response.status == 200) {
      return response.data;
    }
    throw new Error(response.data);
  },
  getDeviceInfo: async function (scheduleid) {
    let response = await HTTP.get(`v1/schedules/${scheduleid}/device-info`);
    if (response.status == 200) {
      return response.data;
    }
    throw new Error(response.data)
  },
  fetchAnomalyList: async function () {
    let response = await HTTP.get('v1/anomaly-report')
    if (response.status == 200) {
      return response.data;
    }
    throw new Error(response.data);
  },
  getSchedulesForPatient: async function (patientID) {
    let response = await HTTP.get(`v1/patients/${patientID}/schedules`);
    if (response.status == 200) {
      return {
        timestamp: response.headers['X-FETCH-TIMESTAMP'],
        schedules: response.data
      };
    }
    throw new Error(response.status);
  },
  downloadPharmacistReport: async function (patientid, start, end) {
    let data = { 'start': start, 'end': end };
    let response = await HTTP.post(`v1/patients/${patientid}/pharmacist-report`, data, { responseType: 'blob' })

    if (response.status == 200) {
      var fileURL = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
      var fileLink = document.createElement('a');

      fileLink.href = fileURL;
      fileLink.setAttribute('download', 'report.pdf');
      document.body.appendChild(fileLink);
      fileLink.click();
      fileLink.remove();
    }
  },
  uploadBulkPatientList: async function (data) {
    let response = await HTTP.post('v1/patients/bulkupload', data)
    if (response.status == 200) {
      return response.data;
    }
    throw new Error(response.data);
  },
};
